// extracted by mini-css-extract-plugin
module.exports = {"container":"AthleteRegistrationPage_container__39RFL","formContainer":"AthleteRegistrationPage_formContainer__22vLS"};